var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../box';
import { containerBaseStyle, responsiveContainerWidthStyle } from './styles';
const Root = styled(Box)(containerBaseStyle, responsiveContainerWidthStyle);
export const Container = forwardRef((props, ref) => {
    const { as, width = 2 } = props, restProps = __rest(props, ["as", "width"]);
    return React.createElement(Root, Object.assign({ "data-ui": "Container" }, restProps, { "$width": width, forwardedAs: as, ref: ref }));
});
Container.displayName = 'Container';
//# sourceMappingURL=container.js.map